"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Constant = require("../../Constant");

var _Error = _interopRequireDefault(require("../Error"));

var _InputContainer = _interopRequireDefault(require("./InputContainer"));

var _Text = require("../../Text");

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Typography = require("../../Typography");

var _theme, _theme2, _theme3, _theme4, _theme5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: ", ";\n  margin-bottom: 15px;\n  position: relative;\n  z-index: 0;\n\n  /* box-shadow is used because the focus outline follows the border-radius curve and is placed outside of the input */\n  & ", ":focus + ", " {\n    ", "\n    /* Visible outline for high contrast mode */\n    outline: 2px solid transparent;\n  }\n\n  & ", ":focus:not([data-focus-visible-added]) + ", " {\n    box-shadow: none;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  cursor: pointer;\n  display: block;\n  margin: 0;\n  padding-left: 16px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n      border: ", " solid ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background: ", ";\n  position: relative;\n  min-width: ", ";\n  height: ", ";\n  flex-basis: ", ";\n  display: inline-block;\n  ", ";\n  cursor: pointer;\n  border-radius: ", ";\n  z-index: 1;\n\n  &:after {\n    content: '';\n    display: ", ";\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 0.6rem;\n    height: 0.9rem;\n    border: solid ", ";\n    border-width: 0 2px 2px 0;\n    transform: translate(-50%, -60%) rotate(45deg);\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  opacity: 0;\n  position: absolute;\n  width: 3rem;\n  height: 3rem;\n  margin: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var borderColor = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, _Constant.Color.DARK_GREY_2), (0, _defineProperty2.default)(_theme, "homepoint", _Constant.Color.HOMEPOINT_NAVY), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, _Constant.Color.BLACK), (0, _defineProperty2.default)(_theme, "caliber", _Constant.Color.CALIBER_NAVY), (0, _defineProperty2.default)(_theme, "figure", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme, "petersendean", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme, "pella", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY), _theme));
var checkColor = (0, _styledTheming.default)('mode', (_theme2 = {}, (0, _defineProperty2.default)(_theme2, _Constant.Themes.HOMEBRIDGE, _Constant.Color.WHITE), (0, _defineProperty2.default)(_theme2, "homepoint", _Constant.Color.WHITE), (0, _defineProperty2.default)(_theme2, _Constant.Themes.SYNERGY_ONE, _Constant.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme2, "caliber", _Constant.Color.WHITE), (0, _defineProperty2.default)(_theme2, "figure", _Constant.Color.WHITE), (0, _defineProperty2.default)(_theme2, "petersendean", _Constant.Color.WHITE), (0, _defineProperty2.default)(_theme2, "pella", _Constant.Color.WHITE), (0, _defineProperty2.default)(_theme2, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.WHITE), _theme2)); // border when checked

var activeBorderColor = (0, _styledTheming.default)('mode', (_theme3 = {}, (0, _defineProperty2.default)(_theme3, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme3, "homepoint", _Constant.Color.HOMEPOINT_LIGHT_BLUE), (0, _defineProperty2.default)(_theme3, _Constant.Themes.SYNERGY_ONE, _Constant.Color.BLACK), (0, _defineProperty2.default)(_theme3, "caliber", _Constant.Color.CALIBER_NAVY), (0, _defineProperty2.default)(_theme3, "figure", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme3, "petersendean", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme3, "pella", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme3, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_ARROW_RED), _theme3));
/**
 * Homepoint is not themed yet.
 * The updated checkboxes use PURPLE_RAIN instead of MOODY_BLURPLE.
 */
// fill color in box

var themedCheckboxColors = (0, _styledTheming.default)('mode', (_theme4 = {}, (0, _defineProperty2.default)(_theme4, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme4, "homepoint", _Constant.Color.HOMEPOINT_LIGHT_BLUE), (0, _defineProperty2.default)(_theme4, _Constant.Themes.SYNERGY_ONE, _Constant.Color.BLACK), (0, _defineProperty2.default)(_theme4, "caliber", _Constant.Color.CALIBER_NAVY), (0, _defineProperty2.default)(_theme4, "figure", _Constant.Color.PURPLE_RAIN), (0, _defineProperty2.default)(_theme4, "petersendean", _Constant.Color.PURPLE_RAIN), (0, _defineProperty2.default)(_theme4, "pella", _Constant.Color.PURPLE_RAIN), (0, _defineProperty2.default)(_theme4, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_ARROW_RED), _theme4));
var focusStyles = (0, _styledTheming.default)('mode', (_theme5 = {
  caliber: "box-shadow: 0 0 0 4px ".concat(_Constant.Color.CALIBER_PASTEL_BLUE, ";")
}, (0, _defineProperty2.default)(_theme5, _Constant.Themes.HOMEBRIDGE, "box-shadow: 0 0 0 4px ".concat(_Constant.Color.HOMEBRIDGE_YELLOW_LIGHT, ";")), (0, _defineProperty2.default)(_theme5, "homepoint", "box-shadow: 0 0 0 4px ".concat(_Constant.Color.HOMEPOINT_LIGHT_BLUE, ";")), (0, _defineProperty2.default)(_theme5, _Constant.Themes.SYNERGY_ONE, _Constant.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme5, "figure", "box-shadow: 0 0 0 4px ".concat(_Constant.Color.FOCUS, ";")), (0, _defineProperty2.default)(_theme5, "pella", "box-shadow: 0 0 0 4px ".concat(_Constant.Color.FOCUS, ";")), (0, _defineProperty2.default)(_theme5, "petersendean", "box-shadow: 0 0 0 4px ".concat(_Constant.Color.FOCUS, ";")), (0, _defineProperty2.default)(_theme5, _Constant.Themes.GUARANTEED_RATE, "box-shadow: 0 0 0 4px ".concat(_Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY, ";")), _theme5));

var Input = _styledComponents.default.input(_templateObject());

var Checkbox = _styledComponents.default.span(_templateObject2(), function (props) {
  return props.small && props.checked ? themedCheckboxColors : _Constant.Color.WHITE;
}, function (props) {
  return props.small ? '2.4rem' : '3rem';
}, function (props) {
  return props.small ? '2.4rem' : '3rem';
}, function (props) {
  return props.small ? '2.4rem' : '3rem';
}, function (props) {
  return (0, _styledComponents.css)(_templateObject3(), props.small ? '1px' : '2px', props.checked && !props.square && props.small ? activeBorderColor : borderColor);
}, function (props) {
  return props.square ? '4px' : '50%';
}, function (props) {
  return props.checked ? 'initial' : 'none';
}, function (props) {
  return props.small ? checkColor : borderColor;
}, function (props) {
  return props.disabled || props.checked ? '' : _Constant.Color.LIGHT_MEDIUM_BACKGROUND_GREY;
}, function (props) {
  return props.disabled ? "\n      background-color: ".concat(_Constant.Color.DISABLE_GREY, ";\n      border: 2px solid ").concat(_Constant.Color.LIGHT_GREY, ";\n\n      &:before {\n        background-color: none;\n        border-color: ").concat(_Constant.Color.LIGHT_GREY, ";\n      }\n  ") : '';
});

var Text = (0, _styledComponents.default)(_Typography.Typography.SmallBodyBold)(_templateObject4());

var FlexLabel = _styledComponents.default.label(_templateObject5(), function (props) {
  return props.alignTop ? 'flex-start' : 'center';
}, Input, Checkbox, focusStyles, Input, Checkbox);

var CheckboxInput = function CheckboxInput(_ref) {
  var alignTop = _ref.alignTop,
      square = _ref.square,
      id = _ref.id,
      label = _ref.label,
      labelNode = _ref.labelNode,
      value = _ref.value,
      checked = _ref.checked,
      errorText = _ref.errorText,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      small = _ref.small,
      descriptiveTextId = _ref.descriptiveTextId,
      asterisks = _ref.asterisks,
      ariaInvalid = _ref.ariaInvalid,
      fsMask = _ref.fsMask,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["alignTop", "square", "id", "label", "labelNode", "value", "checked", "errorText", "onChange", "disabled", "small", "descriptiveTextId", "asterisks", "ariaInvalid", "fsMask"]);

  var inputProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    type: 'checkbox',
    square: square,
    id: id,
    value: value,
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    'aria-invalid': errorText || ariaInvalid ? 'true' : null,
    'aria-describedby': descriptiveTextId
  });

  return /*#__PURE__*/_react.default.createElement(_InputContainer.default, null, /*#__PURE__*/_react.default.createElement(FlexLabel, {
    htmlFor: id,
    alignTop: alignTop,
    className: fsMask ? 'fs-mask' : ''
  }, /*#__PURE__*/_react.default.createElement(Input, inputProps), /*#__PURE__*/_react.default.createElement(Checkbox, {
    checked: checked,
    square: square,
    disabled: disabled,
    small: small
  }), /*#__PURE__*/_react.default.createElement(Text, {
    value: value
  }, labelNode || label, " ", asterisks && /*#__PURE__*/_react.default.createElement(_Text.Asterisk, {
    asterisks: asterisks
  }), /*#__PURE__*/_react.default.createElement(_Error.default, null, errorText))));
};

CheckboxInput.propTypes = {
  /** When true, checkbox will align with top of text */
  alignTop: _propTypes.default.bool,

  /** When true, checkbox will render as a square */
  square: _propTypes.default.bool,

  /** The id used for the checkbox */
  id: _propTypes.default.string.isRequired,

  /** The Label used for the checkbox */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /** A node used for the checkbox label, overrides the label prop */
  labelNode: _propTypes.default.node,

  /** The value of the checkbox */
  value: _propTypes.default.string,

  /** Whether or not the checkbox is checked */
  checked: _propTypes.default.bool.isRequired,

  /** Used for validation */
  errorText: _propTypes.default.string,

  /** Function used to update the checked prop */
  onChange: _propTypes.default.func.isRequired,

  /** Whether or not to disable the checkbox */
  disabled: _propTypes.default.bool,

  /** Small version of checkbox */
  small: _propTypes.default.bool,

  /**
   * Links input helper text or footnote text to the input for assistive technology users.
   * Accepts either the id or multiple space-separated ids of the text you want to link to.
   */
  descriptiveTextId: _propTypes.default.string,

  /** The number of asterisks to render in the label */
  asterisks: _propTypes.default.number,
  ariaInvalid: _propTypes.default.bool,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
CheckboxInput.defaultProps = {
  alignTop: false,
  square: false,
  value: '',
  label: '',
  labelNode: null,
  errorText: '',
  disabled: false,
  small: false,
  descriptiveTextId: null,
  asterisks: null,
  ariaInvalid: false,
  fsMask: true
};
var _default = CheckboxInput;
exports.default = _default;